import {Component, Inject, inject, OnInit} from '@angular/core';
import {ProductType} from "../../Models/CustomerProductItem/ProductType";
import {MatTableDataSource} from "@angular/material/table";
import {ProductTypeService} from "../../Services/Ope/ProductType.service";
import {PageEvent} from "@angular/material/paginator";
import {BaseComponent} from "../common/BaseComponent";
import {GetProductTypesCB} from "../../Ope/ProductType/GetProductTypesCB";
import {BaseDialogComponent} from "../common/BaseDialogComponent";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ProductTypeDTO, PutProductTypeCB} from "../../Ope/ProductType/PutProductTypeCB";
import {GetAllChargersCB} from "../../Ope/Charger/GetAllChargersCB";
import {ChargerService} from "../../Services/Ope/Charger.service";
import {ProductTypeChargerRelationDTO} from "../../Ope/ProductType/ProductTypeChargerRelationDTO";
import {DelProductTypeCB} from "../../Ope/ProductType/DelProductTypeCB";

@Component({
    selector: 'app-productTypeRegistry',
    templateUrl: './productTypeRegistry.component.html',
    styleUrls: ['./productTypeRegistry.component.css', '../common/drawer-style.css']
})
export class ProductTypeRegistryComponent extends BaseComponent implements OnInit {

// ***************************
//   PAGINATION OPTIONS
// ***************************
    readonly PAGESIZE_OPTIONS = [10, 20, 30];
    totalPages?: number;
    totalElements?: number;
    page = 0;
    pageSize = this.PAGESIZE_OPTIONS[0];

    productTypesLoading = false

    productTypes?: ProductType[];
    expandedElement?: ProductType;
    newProductType?: ProductType;
    allChargers: ProductTypeChargerRelationDTO[] = []

    editMode = false;
    formValidationOk = true;

    searchEnabled = false;
    productTypeToFind?: string;

    displayedColumns: string[] = ['name', 'monitored', 'ebike', 'movement', 'actions'];
    tableDataSource!: MatTableDataSource<ProductType>;

    private productTypeService = inject(ProductTypeService);
    private chargerService = inject(ChargerService);

    ngOnInit(): void {
        this.getProductTypes();
    }

    updateProductTypeRelations() {
        if(!!this.expandedElement) {
            const cb = new PutProductTypeCB()
            cb.i.productType = new ProductTypeDTO();
            cb.i.productType.id = this.expandedElement.id;
            let tempChargers: ProductTypeChargerRelationDTO[] = []
            if(!!this.expandedElement.chargers)
            tempChargers = this.expandedElement.chargers.filter(charger => charger.chargerCount > 0);
            cb.i.chargers = !!tempChargers? tempChargers : []
            this.productTypeService.putProductType(cb).subscribe(
                () => {
                    this.gmService.openTranslatedSuccessSnackbar('PRODUCT_TYPE.UPDATE_OK');
                    this.getProductTypes();
                }, (err1: string) => {
                    this.gmService.openErrorSnackbar(err1);
                }
            )
        }
    }

    getProductTypes() {
        this.allChargers = [];
        this.productTypesLoading = true;
        this.tableDataSource = new MatTableDataSource<ProductType>();
        const cb1 = new GetAllChargersCB();
        this.chargerService.getAllChargers(cb1).subscribe(
            () => {
                for (let charger of cb1.o.chargers) {
                    let tempCharger = new ProductTypeChargerRelationDTO();
                    tempCharger.chargerType = charger;
                    tempCharger.chargerCount = 0;
                    tempCharger.taIndex = 0;
                    this.allChargers.push(tempCharger);
                }
                const cb = new GetProductTypesCB();
                cb.i.pageSize = this.pageSize
                cb.i.page = this.page;
                cb.i.textSearch = (!!this.productTypeToFind && this.productTypeToFind != '') ? this.productTypeToFind : undefined;
                this.productTypeService.getProductTypes(cb).subscribe(
                    () => {

                        this.productTypes = cb.o.productTypes.sort((a, b) => a.name.localeCompare(b.name));
                        this.totalElements = cb.o.totalElements;
                        this.totalPages = cb.o.totalPages;
                        this.tableDataSource = new MatTableDataSource<ProductType>(this.productTypes);
                        this.productTypesLoading = false;

                        for (let prodType of this.productTypes) {
                            let tempChargers = !!prodType.chargers? prodType.chargers : [];
                            let tempJson = JSON.stringify(this.allChargers);
                            prodType.chargers = JSON.parse(tempJson);
                            if(!!prodType.chargers) {
                                for (let i = 0; i < tempChargers.length; i++) {
                                    let j = prodType.chargers.findIndex(x => x.chargerType?.id === tempChargers[i].chargerType?.id);
                                    if (j >= 0) {
                                        prodType.chargers[j].chargerCount = tempChargers[i].chargerCount;
                                        prodType.chargers[j].taIndex = tempChargers[i].taIndex;
                                    }
                                }
                            }
                        }

                        // Update the Expanded element
                        if (!!this.expandedElement) {
                            this.expandedElement = this.productTypes.find(a => a.id === this.expandedElement?.id);
                        }
                        this.editMode = false;
                    }, error => {
                        this.gmService.openErrorSnackbar(error);
                        this.tableDataSource = new MatTableDataSource<ProductType>();
                        this.productTypesLoading = false;
                    }
                );
            }, error => {
                console.log(error);
            }
        );
    }

    public getPaginatorData(event: PageEvent): PageEvent {
        this.page = event.pageIndex;
        this.pageSize = event.pageSize;
        this.getProductTypes();
        return event;
    }


    addNewProductType() {
        this.newProductType = new ProductType();
        const dialogRef = this.dialog.open(PutProductTypeDialogComponent, {
            width: '600px',
            data: {
                productType: this.newProductType,
                chargers: this.allChargers
            }
        });

        dialogRef.afterClosed().subscribe(
            (res) => {
                if (res) {
                    this.gmService.openTranslatedSuccessSnackbar('PRODUCT_TYPE.ADD_OK');
                    this.getProductTypes();
                }
            }, error => {
                console.log(error);
            }
        )
    }


    deleteProductType(element: ProductType) {
      const dialogRef = this.dialog.open(AreUSureDeleteProductTypeDialogComponent, {
        width: '500px',
        data: element.name
      });

      dialogRef.afterClosed().subscribe(
        (res) => {
          if (res) {

            const cb = new DelProductTypeCB();
            cb.i.id = element.id;

            this.productTypeService.delProductType(cb).subscribe(
              () => {
                this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCT_TYPE.DELETE_OK'));
                this.getProductTypes();
              }, error => {
                this.gmService.openErrorSnackbar(error);
              }
            )


          }
        }, error => {
          console.log(error);
        }
      );
    }

    hideElement() {
        this.expandedElement = undefined;
    }

    manageFormValidation($event: boolean) {
        this.formValidationOk = $event;
    }

    showDetail(element: any, skipHiding: boolean = false): void {
        if (!skipHiding && !!this.expandedElement && this.expandedElement.id === element.id) {
            // hideElement
            this.hideElement();
            this.editMode = false;
            return;
        }
        this.editMode = false;
        this.expandedElement = this.expandedElement === element ? undefined : element;
    }

    getYesNoIconClass(element: boolean) {
        return element ? 'checkIcon' : 'xIcon';
    }


}


/*--------------------------------
    PUT E015 USER COMPONENT
 -------------------------------*/

@Component({
    templateUrl: 'put-product-type-dialog.html',
    selector: 'app-put-product-type-dialog',
    styleUrls: ['../common/dialog-style.css', 'productTypeRegistry.component.css']
})
export class PutProductTypeDialogComponent extends BaseDialogComponent<PutProductTypeDialogComponent> implements OnInit {

    private productTypeService = inject(ProductTypeService);

    displayedColumns: string[] = ['name', 'power', 'taIndex', 'count'];
    tableDataSource!: MatTableDataSource<ProductTypeChargerRelationDTO>;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        super();
        console.log(this.data.chargers);

    }

    ngOnInit(): void {
        console.log(this.data.chargers);
        this.tableDataSource = new MatTableDataSource<ProductTypeChargerRelationDTO>(this.data.chargers);
    }

    saveProductType() {
        const cb = new PutProductTypeCB()

        cb.i.productType = new ProductType();
        cb.i.productType.name = this.data.productType.name;
        cb.i.productType.ebike = !!this.data.productType.ebike;
        cb.i.productType.monitored = !!this.data.productType.monitored;
        cb.i.productType.moving = !!this.data.productType.moving;
        cb.i.chargers = !!this.data.chargers? this.data.chargers : [];
        this.productTypeService.putProductType(cb).subscribe(
            () => {
                this.closeDialog(true);
            }, (err1: string) => {
                this.gmService.openErrorSnackbar(err1);
            }
        )
        // const cb = new PutE015UserCB();
        //
        // cb.i.id = this.data.user.id;
        // cb.i.firstname = this.data.user.firstname;
        // cb.i.lastname = this.data.user.lastname;
        // cb.i.email = this.data.user.email;
        //
        // this.e015UserService.putE015User(cb).subscribe(
        //     () => {
        //         // Se è un'aggiunta, devo restituire la password da mostrare, altrimenti semplicemente rispondo che è andato tutto bene
        //         this.closeDialog((!!cb.o.password) ? cb.o.password : true);
        //     }, error => {
        //         this.gmService.openErrorSnackbar(error);
        //     }
        // )
    }

    getConnectorClass(element: ProductTypeChargerRelationDTO): string {
        return element.chargerCount > 0 ? "connectorInstalled" : "connectorNotInstalled"
    }
}




/*--------------------------------
     DELETE PRODUCT_TYPE COMPONENT
 -------------------------------*/

@Component({
  templateUrl: '../common/are-u-sure-delete-dialog.html',
  selector: 'app-are-u-sure-delete-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class AreUSureDeleteProductTypeDialogComponent extends BaseDialogComponent<AreUSureDeleteProductTypeDialogComponent> {

  entity = "Tipo Prodotto";

  constructor(@Inject(MAT_DIALOG_DATA) public customerTitle: string) {
    super();
  }

}
